import React from 'react';

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa';

import { Color } from './Colors';

export const TailorMadePage = {
  LEAD_GEN_QUOTE_EDU_EN: 'get-a-quote-edu',
  LEAD_GEN_QUOTE_BIZ_EN: 'get-a-quote-business',
};

export const DocumentType = {
  HOMEPAGE: 'homepage',
  HOMEPAGEWEB: 'homepage_web',
  TESTIMONIAL: 'testimonial',
  RESOURCE: 'resource',
  WOOBINAR: 'woobinar',
  CONTACT: 'contact',
  POST: 'post',
  CATEGORY: 'category',
  TAG: 'tag',
  PAGE: 'page',
  PRICING: 'pricing',
  NOTFOUND: '404',
  NEWSLETTER: 'newsletter',
  EVENTGALLERY: 'event_gallery',
  EVENTTAG: 'event_tag',
  EVENT: 'event',
  QUOTEGENERATOR: 'quote_generator',
};

export const Themes = {
  WOOCLAP: 'wooclap',
  WOOFLASH: 'wooflash',
};

export const Medium = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  LINKEDIN: 'linkedin',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
};

export const SocialNetwork = {
  [Medium.FACEBOOK]: {
    altText: 'facebook-icon',
    icon: <FaFacebookF />,
    iconHoverColor: Color.CHAMBRAY,
    shareAPI: 'https://www.facebook.com/sharer/sharer.php?u=$1',
    link: 'https://www.facebook.com/wooclap',
  },
  [Medium.TWITTER]: {
    altText: 'twitter-icon',
    icon: <FaTwitter />,
    iconHoverColor: Color.BLUE_DODGER,
    shareAPI: 'https://twitter.com/intent/tweet/?text=$2&url=$1&via=wooclap',
    link: 'https://twitter.com/wooclap',
  },
  [Medium.LINKEDIN]: {
    altText: 'linkedin-icon',
    icon: <FaLinkedinIn />,
    iconHoverColor: Color.DEEP_CERULEAN,
    shareAPI: 'https://www.linkedin.com/shareArticle?mini=true&url=$1',
    link: 'https://www.linkedin.com/company/wooclapcompany/',
  },
  [Medium.INSTAGRAM]: {
    altText: 'instagram-icon',
    icon: <FaInstagram />,
    iconHoverColor: Color.MEDIUM_RED_VIOLET,
    shareAPI: '#',
    link: 'https://www.instagram.com/wooclap/',
  },
  [Medium.YOUTUBE]: {
    altText: 'youtube-icon',
    icon: <FaYoutube />,
    iconHoverColor: Color.RED,
    shareAPI: '#',
    link: 'https://www.youtube.com/channel/UCrULut0t78ROET00HgXtvJg',
  },
};

export const Currency = {
  EUR: '_EUR',
  CAD: '_CAD',
  USD: '_USD',
  GBP: '_GBP',
};
